<div class="elearning-card-container">
  <div class="elearning-card">
    <button class="favorite-button" [class.favorited]="elearning?.isFavorite"
      (click)="toggleFavorite(elearning)"
      [matTooltip]="!elearning?.isFavorite ? ('event.add_to_favorite' | translate) : ('event.remove_from_favorite' | translate)">
      ★
    </button>
    @if (elearning?.elearning?.pictures?.length) {
      <img
        [src]="getElearningImage(elearning?.elearning?.pictures[0].name)" class="elearning-image">
    }
    @if (elearning?.elearning?.clearnCategories?.length) {
      <div class="learn-categories">
        @for (lcat of elearning?.elearning?.clearnCategories; track lcat) {
          <div class="learn-category"
            [style.background-color]="lcat.color">
            &#9679;&nbsp;&nbsp;&nbsp;{{lcat.name}}
          </div>
        }
      </div>
    }
    <div class="elearning-content">
      <h3 class="elearning-title">{{elearning?.elearning?.title}}</h3>
      @if (elearning?.elearning?.description) {
        <p class="elearning-description" [innerHTML]="elearning?.elearning?.description"></p>
      }
      <div class="elearning-organization">
        <img class="org-logo" [src]="getImage(elearning?.elearning?.organization?.logo)" >
        <span class="org-name">{{elearning?.elearning?.organization?.name}}</span>
      </div>
    </div>
    <div class="elearning-recommendation">
      <div class="recommender">
        @if (!elearning?.user?.logo) {
          <img class="recommender-avatar" src="assets/images/avatars/profile.jpg">
        }
        @if (elearning?.user?.logo) {
          <img class="recommender-avatar" [src]="getImage(elearning?.user.logo)">
        }
        <div class="recommender-name">{{elearning?.user?.firstName}} {{elearning?.user?.lastName}}</div>
      </div>
      <div class="recommendation-text">{{elearning?.recommendation_text}}</div>
    </div>
    <div class="navigation">
      <button mat-raised-button class="mat-accent" (click)="subscriptionToElearning(elearning?.elearning?.id, index)">{{'elearning.subscribe_to_elearning' | translate}}</button>
      <button mat-raised-button class="mat-accent" (click)="openDetail(elearning, index)">{{'elearning.detail' | translate}}</button>
    </div>
  </div>
</div>

